import * as React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"
import iconFacebook from "../images/icons/facebook.svg"
import iconInstagram from "../images/icons/instagram.svg"
import iconDiscord from "../images/icons/discord.svg"
import iconTwitter from "../images/icons/twitter.svg"
import iconFacebookWhite from "../images/icons/facebook_white.svg"
import iconInstagramWhite from "../images/icons/instagram_white.svg"
import iconDiscordWhite from "../images/icons/discord_white.svg"
import iconTwitterWhite from "../images/icons/twitter_white.svg"

const SocialIcons = ({ isDark = false, small = false }) => {
  const globalsSocial = useStaticQuery(graphql`
    query GlobalsSOcialQuery {
      prismicGlobals {
        data {
          social {
            link
            social_id
          }
        }
      }
    }
  `)

  return (
    <div className="flex">
      {globalsSocial?.prismicGlobals?.data?.social.map(social => {
        const sid = social.social_id
        const socialIcon =
          sid === "facebook"
            ? isDark
              ? iconFacebook
              : iconFacebookWhite
            : sid === "instagram"
            ? isDark
              ? iconInstagram
              : iconInstagramWhite
            : sid === "discord"
            ? isDark
              ? iconDiscord
              : iconDiscordWhite
            : sid === "twitter"
            ? isDark
              ? iconTwitter
              : iconTwitterWhite
            : ""
        return (
          <div className="p-2" key={sid}>
            <a href={social.link} target="_blank" rel="noreferrer">
              <img
                src={socialIcon}
                alt={sid + " icon"}
                className={small ? "w-4" : ""}
              />
            </a>
          </div>
        )
      })}
    </div>
  )
}

SocialIcons.propTypes = {
  isDark: PropTypes.bool,
  small: PropTypes.bool,
}

export default SocialIcons
